export default "__VITE_ASSET__DWpXM4zZ__"